(function () {
  var body = document.body;
  if (!body) return;

  var shopifyRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var currencyCode = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'CLP';
  var moneyFormatter = new Intl.NumberFormat('es-CL', {
    style: 'currency',
    currency: currencyCode,
    maximumFractionDigits: 0
  });

  function buildShopifyUrl(path) {
    return shopifyRoot + String(path || '').replace(/^\//, '');
  }

  function formatMoney(cents) {
    return moneyFormatter.format((Number(cents) || 0) / 100);
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function normalizeVariant(item) {
    if (!item || !item.variant_title || item.variant_title === 'Default Title') return '';
    return item.variant_title;
  }

  function imageMarkup(item) {
    if (!item || !item.image) {
      return '<div class="fw-cart-unit__image fw-cart-unit__image--placeholder"><span>FF</span></div>';
    }

    return '<img class="fw-cart-unit__image" src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.product_title) + '">';
  }

  function lineControls(line, quantity, disabled) {
    var disabledAttr = disabled ? ' disabled aria-disabled="true"' : '';

    return (
      '<div class="fw-cart-unit__controls">' +
        '<div class="fw-cart-stepper" role="group" aria-label="Cantidad">' +
          '<button type="button" class="fw-cart-stepper__button" data-cart-quantity-change data-line="' + line + '" data-next-quantity="' + Math.max(0, quantity - 1) + '"' + disabledAttr + '>-</button>' +
          '<span class="fw-cart-stepper__value">' + quantity + '</span>' +
          '<button type="button" class="fw-cart-stepper__button" data-cart-quantity-change data-line="' + line + '" data-next-quantity="' + (quantity + 1) + '"' + disabledAttr + '>+</button>' +
        '</div>' +
        '<button type="button" class="fw-cart-remove" aria-label="Eliminar producto" data-cart-remove data-line="' + line + '"' + disabledAttr + '>' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 6h18"></path><path d="M8 6V4.8c0-.7.6-1.3 1.3-1.3h5.4c.7 0 1.3.6 1.3 1.3V6"></path><path d="M6.5 6l1 13c.1.8.7 1.5 1.5 1.5h6c.8 0 1.5-.7 1.5-1.5l1-13"></path><path d="M10 10.5v6"></path><path d="M14 10.5v6"></path></svg>' +
        '</button>' +
      '</div>'
    );
  }

  function lineMarkup(item, line, mode, disabled) {
    var variant = normalizeVariant(item);

    return (
      '<article class="fw-cart-unit fw-cart-unit--' + mode + '" data-cart-line="' + line + '" data-cart-line-key="' + escapeHtml(item.key) + '">' +
        '<a class="fw-cart-unit__media" href="' + escapeHtml(item.url) + '">' + imageMarkup(item) + '</a>' +
        '<div class="fw-cart-unit__content">' +
          '<div class="fw-cart-unit__top">' +
            '<h3><a href="' + escapeHtml(item.url) + '">' + escapeHtml(item.product_title) + '</a></h3>' +
            '<strong class="fw-cart-unit__line-price">' + formatMoney(item.final_line_price) + '</strong>' +
          '</div>' +
          '<div class="fw-cart-unit__meta">' +
            (variant ? '<p class="fw-cart-unit__variant">' + escapeHtml(variant) + '</p>' : '') +
            '<p class="fw-cart-unit__unit-price">' + formatMoney(item.final_price) + ' c/u</p>' +
            (mode === 'page' ? '<p class="fw-cart-unit__quantity-label">Cantidad actual: ' + item.quantity + '</p>' : '') +
          '</div>' +
          lineControls(line, item.quantity, disabled) +
        '</div>' +
      '</article>'
    );
  }

  function emptyMarkup() {
    return (
      '<div class="fw-empty-state fw-empty-state--cart">' +
        '<p>Tu carrito está vacío.</p>' +
        '<span>Agrega productos para comenzar tu entrenamiento.</span>' +
        '<a class="fw-button fw-button--solid" href="' + escapeHtml(buildShopifyUrl('collections/all')) + '">Ver productos</a>' +
      '</div>'
    );
  }

  function discountMarkup(cart) {
    if (cart && cart.cart_level_discount_applications && cart.cart_level_discount_applications.length > 0) {
      return cart.cart_level_discount_applications.map(function (discount) {
        return (
          '<div class="fw-cart-discount">' +
            '<div class="fw-cart-discount__row">' +
              '<span>' + escapeHtml(discount.title) + '</span>' +
              '<strong>-' + formatMoney(discount.total_allocated_amount) + '</strong>' +
            '</div>' +
          '</div>'
        );
      }).join('');
    }

    return (
      '<div class="fw-cart-discount">' +
        '<div class="fw-cart-discount__row">' +
          '<span>Compra directa en FitFactor</span>' +
          '<strong>✓</strong>' +
        '</div>' +
        '<small>Los descuentos vigentes se aplican automáticamente o durante el pago.</small>' +
      '</div>'
    );
  }

  function requestJson(url, options) {
    return fetch(url, options).then(function (response) {
      return response.json().catch(function () {
        return {};
      }).then(function (data) {
        if (!response.ok) {
          var message = data.description || data.message || 'No pudimos actualizar el carrito. Intenta nuevamente.';
          throw new Error(message);
        }

        return data;
      });
    });
  }

  function FitWebCart() {
    this.drawer = document.querySelector('[data-cart-drawer]');
    this.drawerRoot = document.querySelector('[data-cart-root]');
    this.backdrop = document.querySelector('[data-cart-backdrop]');
    this.drawerItems = document.querySelector('[data-cart-items]');
    this.drawerFooter = document.querySelector('[data-cart-footer]');
    this.page = document.querySelector('[data-cart-page]');
    this.pageItems = document.querySelector('[data-cart-page-items]');
    this.pageSummary = document.querySelector('[data-cart-summary-card]');
    this.countTargets = Array.prototype.slice.call(document.querySelectorAll('[data-cart-count]'));
    this.subtotalTargets = Array.prototype.slice.call(document.querySelectorAll('[data-cart-subtotal]'));
    this.discountTargets = Array.prototype.slice.call(document.querySelectorAll('[data-cart-discounts]'));
    this.statusTargets = Array.prototype.slice.call(document.querySelectorAll('[data-cart-status]'));
    this.actionTargets = Array.prototype.slice.call(document.querySelectorAll('[data-cart-actions]'));
    this.openTargets = Array.prototype.slice.call(document.querySelectorAll('[data-cart-open], [data-cart-toggle]'));
    this.closeTargets = Array.prototype.slice.call(document.querySelectorAll('[data-cart-close]'));
    this.cart = null;
    this.isOpen = false;
    this.isFetching = false;
    this.pendingLines = {};
    this.lastFocused = null;
  }

  FitWebCart.prototype.init = function () {
    var self = this;

    this.openTargets.forEach(function (trigger) {
      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        self.openCartDrawer();
      });
    });

    this.closeTargets.forEach(function (trigger) {
      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        self.closeCartDrawer();
      });
    });

    if (this.backdrop) {
      this.backdrop.addEventListener('click', function () {
        self.closeCartDrawer();
      });
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && self.isOpen) {
        self.closeCartDrawer();
        return;
      }

      if (event.key === 'Tab' && self.isOpen) {
        self.trapDrawerFocus(event);
      }
    });

    document.addEventListener('click', function (event) {
      var quantityButton = event.target.closest('[data-cart-quantity-change]');
      if (quantityButton) {
        event.preventDefault();
        self.changeCartLine(Number(quantityButton.getAttribute('data-line')), Number(quantityButton.getAttribute('data-next-quantity')));
        return;
      }

      var removeButton = event.target.closest('[data-cart-remove]');
      if (removeButton) {
        event.preventDefault();
        self.changeCartLine(Number(removeButton.getAttribute('data-line')), 0);
      }
    });

    document.addEventListener('click', function (event) {
      var addButton = event.target.closest('[data-product-submit]');
      if (!addButton || addButton.disabled) return;

      var form = addButton.closest('form[data-product-form]');
      if (!form) return;

      // Avoid a second product_added_to_cart from the form submission.
      event.preventDefault();
      self.handleAddToCart(form);
    });

    document.addEventListener('submit', function (event) {
      var form = event.target.closest('form[data-product-form]');
      if (!form) return;

      var submitter = event.submitter;
      var isAcceleratedCheckout = submitter && (
        submitter.name === 'checkout' ||
        submitter.closest('.shopify-payment-button')
      );

      if (isAcceleratedCheckout) return;
      event.preventDefault();
      self.handleAddToCart(form);
    });

    if (this.drawer || this.page) {
      this.getCart().catch(function () {});
    }
  };

  FitWebCart.prototype.setStatus = function (message, kind) {
    this.statusTargets.forEach(function (target) {
      target.textContent = message || '';
      target.dataset.state = kind || '';
    });
  };

  FitWebCart.prototype.setProductFeedback = function (form, message, kind) {
    var target = form ? form.querySelector('[data-product-form-feedback]') : null;
    if (!target) return;
    target.textContent = message || '';
    target.dataset.state = kind || '';
  };

  FitWebCart.prototype.updateCartCount = function (itemCount) {
    this.countTargets.forEach(function (target) {
      target.textContent = itemCount;
      target.hidden = itemCount === 0;
    });
  };

  FitWebCart.prototype.setDrawerLoading = function (loading) {
    if (this.drawer) this.drawer.dataset.loading = loading ? 'true' : 'false';
    if (this.page) this.page.dataset.loading = loading ? 'true' : 'false';
  };

  FitWebCart.prototype.setLinePending = function (line, pending) {
    if (!line) return;

    if (pending) {
      this.pendingLines[line] = true;
    } else {
      delete this.pendingLines[line];
    }

    Array.prototype.slice.call(document.querySelectorAll('[data-cart-line="' + line + '"] [data-cart-quantity-change], [data-cart-line="' + line + '"] [data-cart-remove]')).forEach(function (button) {
      button.disabled = !!pending;
      button.setAttribute('aria-disabled', pending ? 'true' : 'false');
    });
  };

  FitWebCart.prototype.getCart = function () {
    var self = this;
    this.isFetching = true;
    this.setDrawerLoading(true);

    return requestJson(buildShopifyUrl('cart.js'), {
      method: 'GET',
      headers: {
        Accept: 'application/json'
      }
    }).then(function (cart) {
      self.cart = cart;
      self.renderCart(cart);
      document.dispatchEvent(new CustomEvent('fitweb:cart-updated', { detail: { cart: cart } }));
      return cart;
    }).catch(function (error) {
      self.setStatus(error.message || 'No pudimos cargar el carrito. Intenta nuevamente.', 'error');
      throw error;
    }).finally(function () {
      self.isFetching = false;
      self.setDrawerLoading(false);
    });
  };

  FitWebCart.prototype.addToCart = function (formData) {
    return fetch(buildShopifyUrl('cart/add.js'), {
      method: 'POST',
      headers: {
        Accept: 'application/json'
      },
      body: formData
    }).then(function (response) {
      return response.json().catch(function () {
        return {};
      }).then(function (data) {
        if (!response.ok) {
          var message = data.description || data.message || 'No pudimos agregar el producto. Intenta nuevamente.';
          throw new Error(message);
        }

        return data;
      });
    });
  };

  FitWebCart.prototype.changeCartLine = function (line, quantity) {
    var self = this;
    if (!line || this.isFetching || this.pendingLines[line]) return Promise.resolve();

    this.setLinePending(line, true);
    this.setStatus('Actualizando carrito...', 'loading');

    return requestJson(buildShopifyUrl('cart/change.js'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        line: line,
        quantity: quantity
      })
    }).then(function () {
      return self.getCart();
    }).then(function () {
      self.setStatus(quantity === 0 ? 'Producto eliminado del carrito.' : 'Carrito actualizado.', 'success');
    }).catch(function (error) {
      self.setStatus(error.message || 'No pudimos actualizar el carrito. Intenta nuevamente.', 'error');
      throw error;
    }).finally(function () {
      self.setLinePending(line, false);
    });
  };

  FitWebCart.prototype.renderCart = function (cart) {
    var self = this;
    var hasItems = !!(cart && cart.item_count > 0);
    var itemsMarkup = hasItems
      ? cart.items.map(function (item, index) {
          return lineMarkup(item, index + 1, 'drawer', !!self.pendingLines[index + 1]);
        }).join('')
      : emptyMarkup();
    var pageItemsMarkup = hasItems
      ? cart.items.map(function (item, index) {
          return lineMarkup(item, index + 1, 'page', !!self.pendingLines[index + 1]);
        }).join('')
      : emptyMarkup();

    this.updateCartCount(cart ? cart.item_count : 0);

    if (this.drawerItems) {
      this.drawerItems.innerHTML = itemsMarkup;
    }

    if (this.pageItems) {
      this.pageItems.innerHTML = pageItemsMarkup;
    }

    this.discountTargets.forEach(function (target) {
      target.innerHTML = discountMarkup(cart);
    });

    this.subtotalTargets.forEach(function (target) {
      target.textContent = formatMoney(cart ? cart.total_price : 0);
    });

    if (this.drawerFooter) {
      this.drawerFooter.hidden = !hasItems;
    }

    if (this.pageSummary) {
      this.pageSummary.hidden = !hasItems;
    }

    this.actionTargets.forEach(function (target) {
      target.hidden = !hasItems;
    });
  };

  FitWebCart.prototype.openCartDrawer = function () {
    var self = this;
    if (!this.drawer) return;

    this.lastFocused = document.activeElement;

    var reveal = function () {
      self.isOpen = true;
      body.classList.add('is-cart-open');
      self.drawer.setAttribute('aria-hidden', 'false');
      if (self.backdrop) self.backdrop.hidden = false;
      self.openTargets.forEach(function (trigger) {
        trigger.setAttribute('aria-expanded', 'true');
      });
      var closeButton = self.drawer.querySelector('[data-cart-close]');
      (closeButton || self.drawer).focus();
    };

    if (this.cart) {
      reveal();
      return;
    }

    this.getCart().catch(function () {}).finally(reveal);
  };

  FitWebCart.prototype.closeCartDrawer = function () {
    this.isOpen = false;
    body.classList.remove('is-cart-open');
    if (this.drawer) this.drawer.setAttribute('aria-hidden', 'true');
    if (this.backdrop) this.backdrop.hidden = true;
    this.openTargets.forEach(function (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
    });
    if (this.lastFocused && typeof this.lastFocused.focus === 'function') {
      this.lastFocused.focus();
    }
  };

  FitWebCart.prototype.trapDrawerFocus = function (event) {
    if (!this.drawer) return;

    var focusable = Array.prototype.slice.call(this.drawer.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )).filter(function (element) {
      return !element.hidden && element.offsetParent !== null;
    });

    if (!focusable.length) {
      event.preventDefault();
      this.drawer.focus();
      return;
    }

    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  };

  FitWebCart.prototype.handleAddToCart = function (form) {
    var self = this;
    if (!form || form.dataset.loading === 'true') return;

    var submitButton = form.querySelector('[data-product-submit], button[type="submit"]');
    var formData = new FormData(form);

    form.dataset.loading = 'true';
    if (submitButton) submitButton.disabled = true;
    this.setProductFeedback(form, '', '');
    this.setStatus('Agregando producto...', 'loading');

    this.addToCart(formData)
      .then(function () {
        return self.getCart();
      })
      .then(function () {
        self.setStatus('Producto agregado al carrito.', 'success');
        self.setProductFeedback(form, 'Producto agregado al carrito.', 'success');
        self.openCartDrawer();
      })
      .catch(function (error) {
        self.setStatus(error.message || 'No pudimos agregar el producto. Intenta nuevamente.', 'error');
        self.setProductFeedback(form, error.message || 'No pudimos agregar el producto. Intenta nuevamente.', 'error');
      })
      .finally(function () {
        form.dataset.loading = 'false';
        if (submitButton) submitButton.disabled = false;
      });
  };

  new FitWebCart().init();
})();
